var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mega-menu__overlay"})
}
var staticRenderFns = []

export { render, staticRenderFns }